/**
 *
 * popstate 事件
 *
 * 监听ios返回不刷新问题 ios的缓存机制
 */

/**
 * 不知该事件是否有效 等待验证
 */

export default {
  methods: {
    popStateFn() {
      self.location.reload();
      window.history.replaceState({ title: "", url: "#" }, "", "#");
    }
  },
  mounted() {
    window.addEventListener("popState", () => this.popStateFn());
  }
};
